import { motion } from "framer-motion";

function NavBtn({ item }) {
  const { icon: Icon, label, active, onClick, testId } = item;
  return (
    <button data-testid={testId} onClick={onClick} aria-label={label}
      className={`flex-1 flex flex-col items-center justify-center gap-1 min-w-0 h-full transition-colors active:scale-95 ${active ? "text-[#275C0A] dark:text-[#89C94D]" : "text-slate-400 dark:text-slate-300"}`}>
      <Icon className="h-5 w-5 shrink-0" strokeWidth={active ? 2.5 : 2} />
      <span className="text-[10px] font-semibold leading-none truncate max-w-[62px]">{label}</span>
    </button>
  );
}

export default function BottomNav({ items = [], fab }) {
  const half = fab ? Math.ceil(items.length / 2) : items.length;
  const left = items.slice(0, half);
  const right = fab ? items.slice(half) : [];
  return (
    <nav data-testid="mobile-bottom-nav" className="md:hidden fixed inset-x-0 bottom-0 z-40 pointer-events-none">
      <div className="relative mx-auto max-w-md px-3 pb-3 pointer-events-auto">
        <div className="relative flex items-stretch h-16 rounded-2xl border border-border/70 bg-white/90 dark:bg-[#1A1F1A]/90 backdrop-blur-xl shadow-lg shadow-emerald-950/10">
          {left.map((it) => <NavBtn key={it.key} item={it} />)}
          {fab && <div className="w-16 shrink-0" aria-hidden />}
          {right.map((it) => <NavBtn key={it.key} item={it} />)}
          {fab && (
            <div className="absolute left-1/2 -translate-x-1/2 -top-6">
              <motion.button whileTap={{ scale: 0.9 }} animate={{ y: fab.active ? -14 : 0, scale: fab.active ? 1.08 : 1 }}
                transition={{ type: "spring", stiffness: 420, damping: 24 }}
                data-testid={fab.testId} onClick={fab.onClick} aria-label={fab.label}
                className="h-14 w-14 rounded-full bg-[#275C0A] dark:bg-[#5CA323] text-white shadow-lg shadow-emerald-900/40 flex items-center justify-center ring-4 ring-[#F7F5EF] dark:ring-[#121612] transition-colors">
                <fab.icon className="h-6 w-6" />
              </motion.button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
}
